export default "__VITE_ASSET__1hwTD4Ex__"